<template>
  <div>
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-avatar
          :class="'elevation-' + elevation"
          v-bind="attrs"
          v-on="on"
          :color="color"
          :size="size"
        >
        </v-avatar>
      </template>
      <span>{{ hint }}</span>
    </v-tooltip>
  </div>
</template>

<script>
export default {
    props: ['color', 'size', 'hint','elevation']

}
</script>

<style>

</style>
